import React, { useEffect, useState } from 'react';
import './AddProductSidebar.css';
import { Snackbar, Alert } from '@mui/material';

import InputMUI from '../../utils/InputMUI';
import SelectField from '../../utils/SelectMUI';
import { saveProduct } from '../../utils/ActionCreator';

const AddProductSidebar = ({ refreshApi, handleTabOnAdd, isOpen, setIsOpen, editItem, setActiveTab }) => {
  
  const [isLoad, setIsLoad] = useState(false);
  
  // Navigation handlers for new buttons
  const handleBusinessPlanning = () => {
    console.log("Navigating to Business Planning section");
    if (setActiveTab) {
      setActiveTab('Business planning');
    }
  };
  
  const handleProducts = () => {
    console.log("Navigating to Products section");
    if (setActiveTab) {
      setActiveTab('Products');
    }
  };
  
  const handleExpense = () => {
    console.log("Navigating to Expense section");
    if (setActiveTab) {
      setActiveTab('Expense');
    }
  };
  const [emis, setEmis] = useState(['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12']);
  const [payload, setPayload] = useState({
    productId: "",
    productDesc: "",
    processingFee: "",
    interestRate: "",
    noOfEmi: "",
    deploymentRatio: "",
    deploymentNum: "",
    productWeightage: "",
    averageTicketSize: "",
    penaltyCharge: "",
    conversionRatio: ""
  });

  // Validation states
  const [errors, setErrors] = useState({});
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'error'
  });

  // Validation function
  const validateForm = () => {
    const newErrors = {};
    const requiredFields = [
      'productId', 'productDesc', 'processingFee', 'interestRate',
      'noOfEmi', 'deploymentRatio', 'deploymentNum', 'productWeightage',
      'averageTicketSize', 'conversionRatio', 'penaltyCharge'
    ];

    requiredFields.forEach(field => {
      if (!payload[field] || payload[field].toString().trim() === '') {
        newErrors[field] = 'This field is required';
      }
    });

    // validations for numeric fields
    const numericFields = [
      'processingFee', 'interestRate', 'deploymentRatio',
      'deploymentNum', 'productWeightage', 'averageTicketSize', 'conversionRatio', 'penaltyCharge'
    ];

    numericFields.forEach(field => {
      if (payload[field] && isNaN(Number(payload[field]))) {
        newErrors[field] = 'Must be a valid number';
      } else if (payload[field] && Number(payload[field]) < 0) {
        newErrors[field] = 'Must be a positive number';
      }
    });


    // if (payload.interestRate && (Number(payload.interestRate) < 0 || Number(payload.interestRate) > 100)) {
    //   newErrors.interestRate = 'Interest rate must be between 0 and 100';
    // }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSave = () => {
    if (isLoad) return;
    if (validateForm()) {
      setIsLoad(true);
      console.log("Saving product:", payload);

      saveProduct(payload, (callback) => {
        if (callback.status === 200) {
          setSnackbar({
            open: true,
            message: 'Product saved successfully!',
            severity: 'success'
          });


          resetPayload();
          setErrors({});

          refreshApi();
          handleTabOnAdd();
          setIsOpen(false);

        } else {
          setSnackbar({
            open: true,
            message: callback?.data ?? 'Unable to save product, please try again',
            severity: 'error'
          });
        }
        setIsLoad(false);
      }, (onErr) => {
        setSnackbar({
          open: true,
          message: 'Unable to save product, please try again',
          severity: 'error'
        });
        setIsLoad(false);
      })


    } else {
      setSnackbar({
        open: true,
        message: 'Please fill in all required fields correctly',
        severity: 'error'
      });
    }
  };
  const handleEdit = () => {
    if (isLoad) return;
    if (validateForm()) {
      setIsLoad(true);
      console.log("Update product:", payload);

      saveProduct(payload, (callback) => {
        if (callback.status === 200) {
          setSnackbar({
            open: true,
            message: 'Product updated successfully!',
            severity: 'success'
          });


          resetPayload();
          setErrors({});

          refreshApi();
          handleTabOnAdd();
          setIsOpen(false);

        } else {
          setSnackbar({
            open: true,
            message: callback?.data ?? 'Unable to update product, please try again',
            severity: 'error'
          });
        }
        setIsLoad(false);
      }, (onErr) => {
        setSnackbar({
          open: true,
          message: 'Unable to update product, please try again',
          severity: 'error'
        });
        setIsLoad(false);
      })


    } else {
      setSnackbar({
        open: true,
        message: 'Please fill in all required fields correctly',
        severity: 'error'
      });
    }
  };

  const handleChange = (value, name) => {
    setPayload({ ...payload, [name]: value });


    if (errors[name]) {
      setErrors({ ...errors, [name]: '' });
    }
  };

  const handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbar({ ...snackbar, open: false });
  };
  const resetPayload = () => {
    setPayload({
      productId: "",
      productDesc: "",
      processingFee: "",
      interestRate: "",
      noOfEmi: "",
      deploymentRatio: "",
      deploymentNum: "",
      productWeightage: "",
      averageTicketSize: "",
      conversionRatio: "",
      penaltyCharge: ""
    });
  };


  const isFormValid = () => {
    if (isLoad) {
      return false;
    }
    const requiredFields = [
      'productId', 'productDesc', 'processingFee', 'interestRate',
      'noOfEmi', 'deploymentRatio', 'deploymentNum', 'productWeightage',
      'averageTicketSize', 'conversionRatio', 'penaltyCharge'
    ];

    return requiredFields.every(field =>
      payload[field] && payload[field].toString().trim() !== ''
    );
  };


  useEffect(() => {
    console.log("edit item in add product",editItem)
    if (editItem !== null && editItem !== undefined) {
      setPayload({
        id:editItem?.id ?? "",
        productId: editItem?.productId ?? "",
        productDesc: editItem?.productDesc ?? "",
        processingFee: editItem?.processingFee ?? '',
        interestRate: editItem?.interestRate ?? "",
        noOfEmi: editItem?.noOfEmi ?? "",
        deploymentRatio: editItem?.deploymentRatio ?? "",
        deploymentNum: editItem?.deploymentNum ?? "",
        productWeightage: editItem?.productWeightage ?? "",
        averageTicketSize: editItem?.averageTicketSize ?? "",
        conversionRatio: editItem?.conversionRatio ?? "",
        penaltyCharge: editItem?.penaltyCharge ?? ""
      });
    }else{
      if(payload?.id !== "" && payload?.id !== null && payload?.id !== undefined){
        setPayload({...payload,id:null});
      }
    }
  }, [editItem]);


  return (
    <>
      
      <div className="floating-btn business-planning-btn" onClick={handleBusinessPlanning}>
        Business Planning
      </div>
      
      <div className="floating-btn products-btn" onClick={handleProducts}>
        Products
      </div>
      
      <div className="floating-btn expense-btn" onClick={handleExpense}>
        Expense
      </div>

      <div className={`sidebar ${isOpen ? 'open' : ''}`} style={{
        boxShadow: '0 25px 50px rgba(0, 0, 0, 0.25)',
        backdropFilter: 'blur(10px)',
        border: '1px solid rgba(255, 255, 255, 0.1)',
      }}>
        <div className="sidebar-header" style={{
          background: 'rgba(255, 255, 255, 0.1)',
          backdropFilter: 'blur(0px)',
          // borderBottom: '2px solid rgba(0, 0, 0, 0.2)',
          padding: '24px',
          paddingBottom: "10px",
          borderRadius: '0 0 20px 20px',
          // marginBottom: '20px'
        }}>
          <h3 style={{
            color: '#000000',
            margin: 0,
            fontSize: '24px',
            fontWeight: '600',
            letterSpacing: '0.5px',
            // textShadow: '0 2px 4px rgba(0, 0, 0, 0.3)'
          }}>{(editItem !== null && editItem !== undefined)?"Update":"Add"} Product</h3>
          <span
            className="close-btn"
            onClick={() => { setIsOpen(false); resetPayload(); }}
            style={{
              color: '#000000',
              fontSize: '35px',
              fontWeight: '700',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              opacity: '0.8',
              ':hover': {
                opacity: '1',
                transform: 'scale(1.1)'
              }
            }}
          >&times;</span>
        </div>

        <div style={{
          padding: "24px",
          paddingTop: "10px",
          height: 'calc(100% - 120px)',
          overflowY: 'auto',
          scrollbarWidth: 'thin',
          scrollbarColor: 'rgba(255, 255, 255, 0.3) transparent'
        }}>

          <div style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: "20px",

          }}>
            <div style={{
              background: 'rgba(255, 255, 255, 0.15)',
              padding: '20px',
              borderRadius: '16px',
              border: '1px solid rgba(255, 255, 255, 0.2)',
              backdropFilter: 'blur(10px)',
              transition: 'all 0.3s ease',
            }}>
              <InputMUI
                label="Product ID"
                variant="outlined"
                name="productId"
                id="productId"
                type="text"
                size="small"
                required={true}
                onChange={(value) => handleChange(value, "productId")}
                value={payload.productId}
                error={!!errors.productId}
                helperText={errors.productId}
              />
            </div>

            <div style={{
              background: 'rgba(255, 255, 255, 0.15)',
              padding: '20px',
              borderRadius: '16px',
              border: '1px solid rgba(255, 255, 255, 0.2)',
              backdropFilter: 'blur(10px)',
              transition: 'all 0.3s ease'
            }}>
              <InputMUI
                label="Product Description"
                variant="outlined"
                name="productDesc"
                id="productDesc"
                type="text"
                size="small"
                required={true}
                onChange={(value) => handleChange(value, "productDesc")}
                value={payload.productDesc}

                error={!!errors.productDesc}
                helperText={errors.productDesc}
              />
            </div>
          </div>

          <div style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: "20px",

          }}>
            <div style={{
              background: 'rgba(255, 255, 255, 0.15)',
              padding: '20px',
              borderRadius: '16px',
              border: '1px solid rgba(255, 255, 255, 0.2)',
              backdropFilter: 'blur(10px)',
              transition: 'all 0.3s ease'
            }}>
              <InputMUI
                label="Processing Fee"
                variant="outlined"
                name="processingFee"
                id="processingFee"
                type="number"
                size="small"
                required={true}
                onChange={(value) => handleChange(value, "processingFee")}
                value={payload.processingFee}
                error={!!errors.processingFee}
                helperText={errors.processingFee}
              />
            </div>

            <div style={{
              background: 'rgba(255, 255, 255, 0.15)',
              padding: '20px',
              borderRadius: '16px',
              border: '1px solid rgba(255, 255, 255, 0.2)',
              backdropFilter: 'blur(10px)',
              transition: 'all 0.3s ease'
            }}>
              <InputMUI
                label="Interest Rate (%)"
                variant="outlined"
                name="interestRate"
                id="interestRate"
                type="number"
                size="small"
                required={true}
                onChange={(value) => handleChange(value, "interestRate")}
                value={payload.interestRate}
                error={!!errors.interestRate}
                helperText={errors.interestRate}
              />
            </div>
          </div>

          <div style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: "20px",

          }}>
            <div style={{
              background: 'rgba(255, 255, 255, 0.15)',
              padding: '20px',
              borderRadius: '16px',
              border: '1px solid rgba(255, 255, 255, 0.2)',
              backdropFilter: 'blur(10px)',
              transition: 'all 0.3s ease'
            }}>
              <SelectField
                label={'No. of EMI'}
                id="noOfEmi"
                name="noOfEmi"
                data={emis ?? []}
                size={'small'}
                onChange={(value) => handleChange(value, "noOfEmi")}
                value={payload.noOfEmi}
                error={!!errors.noOfEmi}
                helperText={errors.noOfEmi}
              />
            </div>

            <div style={{
              background: 'rgba(255, 255, 255, 0.15)',
              padding: '20px',
              borderRadius: '16px',
              border: '1px solid rgba(255, 255, 255, 0.2)',
              backdropFilter: 'blur(10px)',
              transition: 'all 0.3s ease'
            }}>
              <InputMUI
                label="Deployment Ratio"
                variant="outlined"
                name="deploymentRatio"
                id="deploymentRatio"
                type="number"
                size="small"
                required={true}
                onChange={(value) => handleChange(value, "deploymentRatio")}
                value={payload.deploymentRatio}
                error={!!errors.deploymentRatio}
                helperText={errors.deploymentRatio}
              />
            </div>
          </div>

          <div style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: "20px",

          }}>
            <div style={{
              background: 'rgba(255, 255, 255, 0.15)',
              padding: '20px',
              borderRadius: '16px',
              border: '1px solid rgba(255, 255, 255, 0.2)',
              backdropFilter: 'blur(10px)',
              transition: 'all 0.3s ease'
            }}>
              <InputMUI
                label="Product Weightage"
                variant="outlined"
                name="productWeightage"
                id="productWeightage"
                type="number"
                size="small"
                required={true}
                onChange={(value) => handleChange(value, "productWeightage")}
                value={payload.productWeightage}
                error={!!errors.productWeightage}
                helperText={errors.productWeightage}
              />
            </div>

            <div style={{
              background: 'rgba(255, 255, 255, 0.15)',
              padding: '20px',
              borderRadius: '16px',
              border: '1px solid rgba(255, 255, 255, 0.2)',
              backdropFilter: 'blur(10px)',
              transition: 'all 0.3s ease'
            }}>
              <InputMUI
                label="Deployment Number"
                variant="outlined"
                name="deploymentNum"
                id="deploymentNum"
                type="number"
                size="small"
                required={true}
                onChange={(value) => handleChange(value, "deploymentNum")}
                value={payload.deploymentNum}
                error={!!errors.deploymentNum}
                helperText={errors.deploymentNum}
              />
            </div>
          </div>

          <div style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: "20px",
            // marginBottom: "32px"
          }}>
            <div style={{
              background: 'rgba(255, 255, 255, 0.15)',
              padding: '20px',
              borderRadius: '16px',
              border: '1px solid rgba(255, 255, 255, 0.2)',
              backdropFilter: 'blur(10px)',
              transition: 'all 0.3s ease'
            }}>
              <InputMUI
                label="Average Ticket Size"
                variant="outlined"
                name="averageTicketSize"
                id="averageTicketSize"
                type="number"
                size="small"
                required={true}
                onChange={(value) => handleChange(value, "averageTicketSize")}
                value={payload.averageTicketSize}
                error={!!errors.averageTicketSize}
                helperText={errors.averageTicketSize}
              />
            </div>

            <div style={{
              background: 'rgba(255, 255, 255, 0.15)',
              padding: '20px',
              borderRadius: '16px',
              border: '1px solid rgba(255, 255, 255, 0.2)',
              backdropFilter: 'blur(10px)',
              transition: 'all 0.3s ease'
            }}>
              <InputMUI
                label="Conversion Ratio"
                variant="outlined"
                name="conversionRatio"
                id="conversionRatio"
                type="number"
                size="small"
                required={true}
                onChange={(value) => handleChange(value, "conversionRatio")}
                value={payload.conversionRatio}
                error={!!errors.conversionRatio}
                helperText={errors.conversionRatio}
              />
            </div>
          </div>
          <div style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: "20px",
            // marginBottom: "32px"
          }}>
            <div style={{
              background: 'rgba(255, 255, 255, 0.15)',
              padding: '20px',
              borderRadius: '16px',
              border: '1px solid rgba(255, 255, 255, 0.2)',
              backdropFilter: 'blur(10px)',
              transition: 'all 0.3s ease'
            }}>
              <InputMUI
                label="Penalty Charge"
                variant="outlined"
                name="penaltyCharge"
                id="penaltyCharge"
                type="number"
                size="small"
                required={true}
                onChange={(value) => handleChange(value, "penaltyCharge")}
                value={payload.penaltyCharge}
                error={!!errors.penaltyCharge}
                helperText={errors.penaltyCharge}
              />
            </div>


          </div>

          {/* Save Button */}
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            marginTop: '22px'
          }}>
            <button
              onClick={() => ((editItem !== null && editItem !== undefined) ? handleEdit() : handleSave())}

              disabled={!isFormValid()}
              style={{
                background: isFormValid()
                  ? 'linear-gradient(145deg, #00807a, #004d49)'
                  : 'linear-gradient(145deg, #cccccc, #999999)',
                border: 'none',
                borderRadius: '50px',
                padding: '16px 48px',
                color: '#ffffff',
                fontSize: '16px',
                fontWeight: '600',
                cursor: isFormValid() ? 'pointer' : 'not-allowed',
                transition: 'all 0.3s ease',
                // boxShadow: isFormValid() 
                //   ? '0 8px 25px #008078' 
                //   : '0 4px 12px rgba(0,0,0,0.2)',
                letterSpacing: '0.5px',
                textTransform: 'uppercase',
                minWidth: '200px',
                position: 'relative',
                overflow: 'hidden',
                opacity: isFormValid() ? 1 : 0.6
              }}
              onMouseEnter={(e) => {
                if (isFormValid()) {
                  e.target.style.transform = 'translateY(-2px)';
                  e.target.style.boxShadow = '0 2px 10px #008078';
                }
              }}
              onMouseLeave={(e) => {
                if (isFormValid()) {
                  e.target.style.transform = 'translateY(0)';
                  e.target.style.boxShadow = '0 0px 0px #008078';
                }
              }}
            >{!isLoad ? ((editItem !== null && editItem !== undefined)?"Update Product":"Save Product") : ((editItem !== null && editItem !== undefined) ?"Updating" :"Saving...")}

            </button>
          </div>
        </div>
      </div>

      {/* Snackbar for notifications */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={2000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbar.severity}
          variant="filled"
          sx={{ width: '100%' }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default AddProductSidebar;